import { useCallback, useMemo, useState } from 'react'
import { GameInHouseConfig } from '../config/types'

export const useGameInHouseConfig = (): GameInHouseConfig & {
  onUpdateConfig?: (key: GameInHouseConfig) => void
} => {
  const [config, setConfig] = useState<GameInHouseConfig>({
    volumeEnable: !!Number(localStorage.getItem('volume_play_pliko') || 1),
    instanceBetEnable: !!Number(localStorage.getItem('instance_bet_enable') || 0),
    maxBetButtonEnable: !!Number(localStorage.getItem('max_bet_button_enable') || 0),
    hotkeyEnable: !!Number(localStorage.getItem('hot_key_eanble') || 0),
  })

  const onUpdateConfig = useCallback(
    (data: GameInHouseConfig) => {
      const result = {
        ...config,
        ...data,
      }
      localStorage.setItem('volume_play_pliko', `${result.volumeEnable ? 1 : 0}`)
      localStorage.setItem('instance_bet_enable', `${result.instanceBetEnable ? 1 : 0}`)
      localStorage.setItem('max_bet_button_enable', `${result.maxBetButtonEnable ? 1 : 0}`)
      localStorage.setItem('hot_key_eanble', `${result.hotkeyEnable ? 1 : 0}`)

      setConfig(result)
    },
    [config],
  )

  return useMemo(
    () => ({
      ...config,
      onUpdateConfig,
    }),
    [config, onUpdateConfig],
  )
}
